@if (concept) {
  <div [ngClass]="cssClassName">
    <div [class.feedback-target]="feedbackMode.isActive"
         (click)="onConceptSectionClick($event)">
      @if (classificationFields?.length) {
        <div class="fset ccl">
          @for (field of classificationFields; track field.oid) {
            <div pub-field-render [field]="field"
                 (conceptSelected)="selectConcept($event)"></div>
          }
        </div>
      }
      @if (hasRelations) {
        <div class="fset rel f">
          <div class="label" i18n="@@resultView.relations">Relations</div>
          <div class="value">
            <pub-render-relations [conceptId]="concept.id" [textComponent]="true"
                                  (conceptSelected)="selectConcept($event)"></pub-render-relations>
          </div>
        </div>
      }
      @if (conceptFields?.length) {
        <div class="fset cl">
          @for (field of conceptFields; track field.oid) {
            <div pub-field-render [field]="field"
                 (conceptSelected)="selectConcept($event)"></div>
          }
        </div>
      }
    </div>
    @for (langCode of sourceLangCodes; track langCode) {
      @if (hasTermInLanguage(langCode)) {
        <mat-card appearance="outlined" class="ll source">
          <mat-card-subtitle><span pub-field-render [field]="getLanguageField(langCode)"></span></mat-card-subtitle>
          @if (hasSelectedTerm()) {
            <div class="term-item" [class.feedback-target]="feedbackMode.isActive"
                 (click)="onTermClick(sourceTerm!, $event)">
              <pub-term-render [term]="sourceTerm" [focus]="true"
                               (conceptSelected)="selectConcept($event)"></pub-term-render>
            </div>
          }
          @for (term of getSynonymTerms(langCode); track term.id) {
            <div class="term-item" [class.feedback-target]="feedbackMode.isActive"
                 (click)="onTermClick(term, $event)">
              <pub-term-render [term]="term" (conceptSelected)="selectConcept($event)"></pub-term-render>
            </div>
          }
        </mat-card>
      }
    }
    @for (langCode of getTargetLanguages(); track langCode) {
      @if (hasTermInLanguage(langCode)) {
        <mat-card appearance="outlined" class="ll target">
          <mat-card-subtitle><span pub-field-render [field]="getLanguageField(langCode)"></span></mat-card-subtitle>
          @for (term of getTerms(langCode); track term.id) {
            <div class="term-item" [class.feedback-target]="feedbackMode.isActive"
                 (click)="onTermClick(term, $event)">
              <pub-term-render [term]="term" (conceptSelected)="selectConcept($event)"></pub-term-render>
            </div>
          }
        </mat-card>
      }
    }
  </div>
}
